import { useInfiniteQuery } from '@tanstack/react-query'

import { get } from 'utils/http'

// Cursor-paginated: each page returns { mappings, lastValue }; lastValue is the next cursor (empty when done). Empty search/cursor are omitted from the query.
export const useNameToDomainMappings = (search = '') => {
  return useInfiniteQuery({
    queryKey: ['nameToDomain', search],
    queryFn: ({ pageParam }) =>
      get('/management/companies/name_to_domain/search', {
        query: {
          limit: 25,
          ...(search ? { query: search } : {}),
          ...(pageParam ? { lastValue: pageParam } : {}),
        },
      }),
    initialPageParam: '',
    getNextPageParam: (lastPage: any) => lastPage.lastValue || undefined,
  })
}
